import * as React from 'react';
import { ArticleHeading4, Caption } from '@cian/ui-kit';

import * as styles from './AboutRealtorDesktop.css';

export interface ICounter {
  label: string;
  text: string;
}

interface ICountersProps {
  counters: ICounter[];
}

export const Counters = ({ counters }: ICountersProps) => {
  return (
    <div className={styles['counters']}>
      {counters.map(({ label, text }) => (
        <div key={label} className={styles['counters-item']}>
          <Caption color="text-secondary-default">{label}</Caption>
          <ArticleHeading4>{text}</ArticleHeading4>
        </div>
      ))}
    </div>
  );
};
